const DEEP_LINK_PREFIX = "estiapayment://pay/v1/";

function extractPaymentPath(deepLink: string): string | null {
  if (!deepLink.startsWith(DEEP_LINK_PREFIX)) return null;
  const tail = deepLink.slice(DEEP_LINK_PREFIX.length);
  try {
    return decodeURIComponent(tail);
  } catch {
    return tail;
  }
}

function encodeIntentPath(paymentPath: string): string {
  return paymentPath
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/");
}

export function isAndroidBrowser(): boolean {
  return /Android/i.test(navigator.userAgent);
}

export function isMobileBrowser(): boolean {
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function androidIntentUrl(paymentPath: string): string {
  const pathSeg = encodeIntentPath(paymentPath);
  const pkg = (import.meta.env.VITE_ESTIA_ANDROID_PACKAGE || "").trim();
  const parts = [
    `intent://pay/v1/${pathSeg}#Intent;scheme=estiapayment`,
    "action=android.intent.action.VIEW",
  ];
  if (pkg) {
    parts.push(`package=${pkg}`);
  }
  return `${parts.join(";")};end`;
}

export function buildEstiaAppLaunchUrl(deepLink: string): string {
  const path = extractPaymentPath(deepLink);
  if (!path) {
    return deepLink;
  }
  if (isAndroidBrowser()) {
    return androidIntentUrl(path);
  }
  return deepLink;
}
